import INFTCollections from '../../models/INFTCollections'
import HeroesOfNFTCard from '../../nftFormats/HerosOfNFT/Card/HeroesOfNFTCard'
import HeroesOfNFTDetail from '../../nftFormats/HerosOfNFT/Detail/HerosOfNFTDetail'
import HeroesOfNFTActivtyDetail from '../../nftFormats/HerosOfNFT/Activity/HeroesOfNFTActivtyDetail'
import HeroesOfNFTLogo from '../../../../assets/nft-logo/heroesOfNFT.jpg'

export const HeroesOfNFTDataData: INFTCollections = {
  id: 'heroesOfNFT',
  tokenAddress: '0xbd7bd0b4650d324e3ea6f734faa3fc37d80b7d82',
  name: 'Heroes of NFT',
  cardFormat: HeroesOfNFTCard,
  detailFormat: HeroesOfNFTDetail,
  activityFormat: HeroesOfNFTActivtyDetail,
  category: 2,
  creatorAddress: '0x035dce477179C8bA5D4C2406b73ab25885BB0380',
  logo: HeroesOfNFTLogo,
  website: 'https://www.heroesofnft.com/',
  twitter: 'heroesofnft',
  telegram: 't.me/heroesofNFTofficial',
  discord: 'https://discord.com/invite/ngvATGZ6QE'
}

export const HeroesOfNFTCategoryData = {
  [HeroesOfNFTDataData.tokenAddress.toLowerCase()]: HeroesOfNFTDataData.category
}
